import { z } from "zod";

import {
	KidsPolicyTypeSchema,
	SiteControllerSettingTllInputSchema,
	TllMasterObjectInputSchema,
	TllPlanTypeSchema,
	TllRoomObjectInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

export const siteControllerSettingTllInputZodSchema = SiteControllerSettingTllInputSchema.extend({
	tll: z.lazy(() =>
		TllMasterObjectInputSchema.extend({
			rooms: z.array(
				z.lazy(() =>
					TllRoomObjectInputSchema.extend({
						inSale: z.boolean(),
						inSaleForChillnnPlan: z.boolean().nullish(),
						tllRoomTypeName: z.string(),
						roomMinimumNum: z.number().nullish(),
						roomMaximumNum: z.number().nullish(),
						roomType: z.string().nullish(),
						relationalRoomTypeID: z.string().nullish(),
					}),
				),
			),
			plans: z.array(
				z.object({
					roomStatus: z.array(
						z.object({
							tllRoomID: z.string(),
							inSale: z.boolean(),
						}),
					),
					tllPlanID: z.string(),
					planName: z.string(),
					isRoomPrice: z.boolean(),

					saleStart: z.string().nullable().optional(),
					saleEnd: z.string().nullable().optional(),
					stayableStart: z.string().nullable().optional(),
					stayableEnd: z.string().nullable().optional(),

					requiredPrepMilli: z.number().nullish(),
					minimumPeopleNum: z.number().nullish(),
					maximumPeopleNum: z.number().nullish(),
					minimumStayDate: z.number().nullish(),
					maximumStayDate: z.number().nullish(),

					acceptPrimarySchoolUpperGrade: z.boolean(),
					countablePrimarySchoolUpperGrade: z.boolean(),

					primarySchoolUpperGradeAmount: z.number().nullish(),
					primarySchoolUpperGradeAmountPolicyType: KidsPolicyTypeSchema.nullish(),

					acceptPrimarySchoolLowerGrade: z.boolean(),
					countablePrimarySchoolLowerGrade: z.boolean(),

					primarySchoolLowerGradeAmount: z.number().nullish(),
					primarySchoolLowerGradeAmountPolicyType: KidsPolicyTypeSchema.nullish(),

					acceptInfant: z.boolean(),
					countableInfant: z.boolean(),
					infantAmount: z.number().nullish(),
					infantPolicyType: KidsPolicyTypeSchema.nullish(),
					acceptInfantWithoutFoodAndBed: z.boolean(),
					countableInfantWithoutFoodAndBed: z.boolean(),
					infantWithoutFoodAndBedAmount: z.number().nullish(),
					infantWithoutFoodAndBedPolicyType: KidsPolicyTypeSchema.nullish(),
					planType: TllPlanTypeSchema,
				}),
			),
			tllID: z
				.string()
				.min(6)
				.max(6)
				.refine((val) => val.length === 6, {
					message: "TLL IDは6文字で入力してください",
				}),
		}),
	),
});

export type SiteControllerSettingTllInputZodSchemaType = z.infer<typeof siteControllerSettingTllInputZodSchema>;
